export function svgBase64ToAscii(svgBase64: string): string {
    const base64String = svgBase64.replace('data:image/svg+xml;base64,', '');
    const buffer = Buffer.from(base64String, 'base64');

    return buffer.toString('ascii');
}
